export const isProductionSeoEnabled = () =>
  process.env.NEXT_PUBLIC_USE_META === 'true';
